export const filterInitialData = {
    id: "",
    price_from: "",
    price_to: "",
    category: "",
    brand: "",
    brandName: "",
    category_name:""
};
export const TenantDetailTabs = [
    {
      key: "general",
      label: "admin.tenantDetails.tabs.generalInfo",
    },
    { key: "branches", label: "admin.tenantDetails.tabs.branches" },
    { key: "users", label: "admin.tenantDetails.tabs.users" },
    { key: "catalog", label: "admin.tenantDetails.tabs.catalog" },
    {
      key: "compliance",
      label: "admin.tenantDetails.tabs.complianceDocuments",
    },
    {
      key: "purchase-requests",
      label: "admin.tenantDetails.tabs.purchaseRequests",
    },
    {
      key: "purchase-orders",
      label: "admin.tenantDetails.tabs.purchaseOrders",
    },
  ];